<script>
import useSharedData from "@/use/SharedData";
import useSharedMethod from "@/use/SharedMethod";
import useSharedSelectData from "@/use/SharedSelectData";
import useTools from "@/use/Tools";
import {useCnasAgencyStore} from "@/stores/CnasAgency";
import {useSecurityStore} from "@/stores/Security";
import axios from "axios";
import {watch} from "vue";

export default {
    setup() {
        const {
            total,
            loading,
            filter,
        } = useSharedData();

        const {transformFilterValues} = useSharedMethod();

        const {cnasAgencyModules} = useSharedSelectData();

        const {$i18n, $router} = useTools();

        const cnasAgencyStore = useCnasAgencyStore();
        const securityStore = useSecurityStore();

        const headers = [
            {
                text: "...",
                align: "left",
                sortable: true,
                value: "action",
                width: "0px",
            },
            {
                text: $i18n.t("common.code"),
                align: "left",
                sortable: true,
                value: "code",
                width: "0px",
            },
            {
                text: $i18n.t("common.name"),
                align: "left",
                sortable: true,
                value: "name",
            },
            {
                text: $i18n.t("common.arabic_name"),
                align: "left",
                sortable: true,
                value: "arabicName",
            },
            {
                text: $i18n.t("common.membership_number"),
                align: "left",
                sortable: true,
                value: "membershipNumber",
            },
            {
                text: $i18n.t("common.accounting_code"),
                align: "left",
                sortable: true,
                value: "accountingCode",
            },
            {
                text: $i18n.t("common.agency_code"),
                align: "left",
                sortable: true,
                value: "agencyCode",
            },
        ];

        const actions = [
            {
                title: $i18n.t("common.edit"),
                icon: 'mdi-pencil-box-multiple',
                color: 'orange',
                access: () => securityStore.authorities['UPDATE_ADMIN_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'cnas_agencies.edit', params: { id: item.id }})
                },
            },
            {
                title: $i18n.t("common.delete"),
                icon: 'mdi-trash-can',
                color: 'red',
                access: () => securityStore.authorities['UPDATE_ADMIN_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'cnas_agencies.delete', params: { id: item.id }})
                },
            },
        ];

        function findAll() {
            loading.value = true;
            axios.get('/cnasAgencies', {params: transformFilterValues(filter.value)}).then((response) => {
                total.value = response.data.length;
                cnasAgencyStore.setCnasAgencies(response.data);
            }).finally(() => {
                loading.value = false;
            });
        }

        watch(() => filter.value, () => {
            findAll();
        }, {deep: true, immediate: true});

        return {
            cnasAgencyStore,
            securityStore,
            headers,
            actions,
            total,
            loading,
            filter,
            cnasAgencyModules,
            findAll,
        };
    },
}
</script>

<template>
    <div>
        <w-app
            :title="$t('module.cnas_agency')"
            show-total
            :total="total"
        >
            <template v-slot:rightToolbar>
                <w-btn-reload
                    :loading="loading"
                    @press="findAll"
                />
                <w-btn-add
                    :show="securityStore.authorities['UPDATE_ADMIN_PARAM']"
                    @press="$router.push({ name: 'cnas_agencies.add' })"
                />
            </template>
            <template v-slot:content>
                <w-data-table
                    :headers="headers"
                    :actions="actions"
                    :items="cnasAgencyStore.cnasAgencies"
                    :total="total"
                    :loading="loading"
                    sort-by="name"
               >
                    <template v-slot:[`item.code`]="{ item }">
                        <w-chip :text="item.code"/>
                    </template>
                    <template v-slot:[`item.name`]="{ item }">
                        <w-inline-text bold :text="item.name"/>
                    </template>
                    <template v-slot:[`item.membershipNumber`]="{ item }">
                        <w-chip color="teal" :text="item.membershipNumber"/>
                    </template>
                </w-data-table>
            </template>
        </w-app>
        <router-view/>
    </div>
</template>